const productDetailList = [
    {
        id: 1,
        pid: 1,
        name: '流量传感器',
        url: '/product/1',
        img: 'https://2024.baidianguanjia.com/imgs/llcgq1.jpg'
    },
    {
        id: 2,
        pid: 1,
        name: '液位传感器',
        url: '/product/2',
        img: 'https://2024.baidianguanjia.com/imgs/ywcgq1.jpg'
    },
    {
        id: 3,
        pid: 1,
        name: '光学器件',
        url: '/product/3',
        img: 'https://2024.baidianguanjia.com/imgs/gxqj1.jpg'
    },
    {
        id: 4,
        pid: 1,
        name: '电源',
        url: '/product/4',
        img: 'https://2024.baidianguanjia.com/imgs/dy1.jpg'
    },
    {
        id: 5,
        pid: 1,
        name: '测试仪',
        url: '/product/5',
        img: 'https://2024.baidianguanjia.com/imgs/cyq1.jpg'
    },
    {
        id: 6,
        pid: 1,
        name: '编码器',
        url: '/product/6',
        img: 'https://2024.baidianguanjia.com/imgs/bmq1.png'
    },
    {
        id: 7,
        pid: 2,
        name: '自动喷枪',
        url: '/product/7',
        img: 'https://2024.baidianguanjia.com/imgs/zdpq1.png'
    },
    {
        id: 8,
        pid: 2,
        name: '微电机',
        url: '/product/8',
        img: 'https://2024.baidianguanjia.com/imgs/wdj1.jpg'
    },
    {
        id: 9,
        pid: 2,
        name: '轴承',
        url: '/product/9',
        img: 'https://2024.baidianguanjia.com/imgs/zc3.jpg'
    },
    {
        id: 10,
        pid: 2,
        name: '联轴器',
        url: '/product/10',
        img: 'https://2024.baidianguanjia.com/imgs/lzq4.jpg'
    },
    {
        id: 11,
        pid: 2,
        name: '制动器',
        url: '/product/11',
        img: 'https://2024.baidianguanjia.com/imgs/zdq2.jpg'
    },
    {
        id: 12,
        pid: 2,
        name: '齿轮箱',
        url: '/product/12',
        img: 'https://2024.baidianguanjia.com/imgs/clx1.jpg'
    },
    {
        id: 13,
        pid: 3,
        name: '液压缸',
        url: '/product/13',
        img: 'https://2024.baidianguanjia.com/imgs/yyg2.png'
    },
    {
        id: 14,
        pid: 3,
        name: '液压阀',
        url: '/product/14',
        img: 'https://2024.baidianguanjia.com/imgs/yyf2.jpg'
    },
    {
        id: 15,
        pid: 3,
        name: '气缸',
        url: '/product/15',
        img: 'https://2024.baidianguanjia.com/imgs/qg4.jpg'
    },
    {
        id: 16,
        pid: 3,
        name: '气动阀',
        url: '/product/16',
        img: 'https://2024.baidianguanjia.com/imgs/qdf1.jpg'
    },
    {
        id: 17,
        pid: 3,
        name: '执行器',
        url: '/product/17',
        img: 'https://2024.baidianguanjia.com/imgs/zxq2.jpg'
    },
    {
        id: 18,
        pid: 3,
        name: '快速接头',
        url: '/product/18',
        img: 'https://2024.baidianguanjia.com/imgs/ksjt.jpg'
    },
    {
        id: 19,
        pid: 4,
        name: '中心架',
        url: '/product/19',
        img: 'https://2024.baidianguanjia.com/imgs/zxj.jpg'
    },
    {
        id: 20,
        pid: 4,
        name: '电动工具',
        url: '/product/20',
        img: 'https://2024.baidianguanjia.com/imgs/ddgj2.png'
    },
    {
        id: 21,
        pid: 4,
        name: '气爪',
        url: '/product/21',
        img: 'https://2024.baidianguanjia.com/imgs/qz1.jpg'
    },
    {
        id: 22,
        pid: 4,
        name: '卡盘',
        url: '/product/22',
        img: 'https://2024.baidianguanjia.com/imgs/kp1.jpg'
    },
    {
        id: 23,
        pid: 4,
        name: '气动工具',
        url: '/product/23',
        img: 'https://2024.baidianguanjia.com/imgs/qdgj1.jpg'
    },
    {
        id: 24,
        pid: 4,
        name: '手动工具',
        url: '/product/24',
        img: 'https://2024.baidianguanjia.com/imgs/sdgj1.jpg'
    },
]
export function getPList(max) {
    let productList = getProductListByNo(0,max-1,1)
    return productList || []
}
export function getProductMenuList() {
    const productMenuList = [
        {
            id: 1,
            name: '电子电气',
            url: '/product/index?mId=1&pageNo=1'
        },
        {
            id: 2,
            name: '机械传动',
            url: '/product/index?mId=2&pageNo=1'
        },
        {
            id: 3,
            name: '液压气动',
            url: '/product?mId=3&pageNo=1'
        },
        {
            id: 4,
            name: '工具夹箱',
            url: '/product/index?mId=4&pageNo=1'
        },
    ]
    return productMenuList || []
}

export function getProductDetailPage(pageNo,pageSize,mId) {
    let totalNum = productDetailList.length
    let pageObj = calculatePagination(pageNo, pageSize, totalNum)
    let list = getProductListByNo(pageObj.startNo, pageObj.endNo,mId)
    pageObj.data = list
    return pageObj
}

function getProductListByNo(start, end,mId) {
    let list = []
    let dataSourceList = []
    for (let productDetailListElement of productDetailList) {
        if(mId == productDetailListElement.pid){
            dataSourceList.push(productDetailListElement)
        }
    }
    for (let i = 1; i <= dataSourceList.length; i++) {
        if(start <= i && i <= end){
            list.push(dataSourceList[i-1])
        }
    }
    return list
}

export function getProductDetailById(ndId) {
    let resultObj = {}
    for (let i = 0; i < productDetailList.length; i++) {
        let obj = productDetailList[i]
        if(obj.id == ndId){
            resultObj = obj
            break
        }
    }
    return resultObj
}

// 计算分页
export function calculatePagination(currentPage, pageSize, totalItems) {
    // 计算总页数
    const totalPages = Math.ceil(totalItems / pageSize);

    // 计算起始和结束的页码
    const startPage = Math.max(1, currentPage - 1);
    const endPage = Math.min(totalPages, currentPage + 1);

    // 计算左侧和右侧的边界页码
    const boundaryPages = 2;
    let leftBoundary = Math.max(1, startPage - boundaryPages);
    let rightBoundary = Math.min(totalPages, endPage + boundaryPages);

    // 如果左侧边界小于1，右侧边界需要相应减少
    if (leftBoundary < 1) {
        rightBoundary = Math.min(totalPages, rightBoundary + (1 - leftBoundary));
        leftBoundary = 1;
    }

    // 如果右侧边界大于总页数，左侧边界需要相应增加
    if (rightBoundary > totalPages) {
        leftBoundary = Math.max(1, leftBoundary - (rightBoundary - totalPages));
        rightBoundary = totalPages;
    }

    let startNo = 1
    if(leftBoundary <= 1){
        startNo = 1
    } else{
        startNo = parseInt((leftBoundary - 1) * pageSize)
    }
    let endNo = parseInt(leftBoundary * pageSize)

    // 生成页码数组
    const pages = Array.from({ length: rightBoundary - leftBoundary + 1 }, (v, k) => leftBoundary + k);

    return {
        totalPages: totalPages,
        startPage: startPage,
        endPage: endPage,
        leftBoundary: leftBoundary,
        rightBoundary: rightBoundary,
        startNo: startNo,
        endNo: endNo,
        pages: pages,
        pageSize: pageSize
    };
}
